import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Form } from 'react-bootstrap';
import { css, StyleSheet } from 'aphrodite';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';

import { blackberry, coolGrey, grape, greyStroke, squidInk, white } from 'lib/css/colors';
import { selectStyles } from 'lib/css/selectStyles';
import { VendorConfigurationStatusOptions } from 'lib/enums/VendorConfigurationStatus';

function VendorFilters({ isDPPartner, setIsDPPartner, loading, setShowFilters }) {
  const [selectedDPPartnerStatus, setSelectedDPPartnerStatus] = useState(isDPPartner || '');

  useEffect(() => {
    setSelectedDPPartnerStatus(isDPPartner || '');
  }, [isDPPartner]);

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.header)}>
        <h4 className={css(styles.title)}>Filters</h4>
        <Button
          variant="link"
          className={css(styles.closeButton)}
          onClick={() => setShowFilters(false)}
          aria-label="Close filters"
        >
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </div>
      <div className={css(styles.divider)} />
      <div className={css(styles.filtersBody)}>
        <Form.Group className={css(styles.formGroup)}>
          <Form.Label className={css(styles.label)}>DP Partner</Form.Label>
          <Select
            isClearable
            options={VendorConfigurationStatusOptions}
            value={
              VendorConfigurationStatusOptions.find(
                option => option?.value === selectedDPPartnerStatus,
              ) || null
            }
            placeholder="Select Distributor DP Partner Status"
            onChange={option => setSelectedDPPartnerStatus(option?.value || '')}
            styles={selectStyles}
          />
        </Form.Group>
      </div>
      <div className={css(styles.footer)}>
        <Button
          className={css(styles.applyButton)}
          disabled={loading}
          onClick={() => {
            setIsDPPartner(selectedDPPartnerStatus);
            setShowFilters(false);
          }}
        >
          Apply Filters
        </Button>
        <Button
          className={css(styles.clearButton)}
          variant="outline-secondary"
          onClick={() => {
            setSelectedDPPartnerStatus('');
            setIsDPPartner('');
          }}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '90vh',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    color: squidInk,
    margin: 0,
  },
  closeButton: {
    background: 'none',
    border: 'none',
    color: coolGrey,
    fontSize: 18,
    cursor: 'pointer',
    padding: 8,
    borderRadius: 6,
    ':hover': {
      backgroundColor: `${grape}15`,
      color: grape,
    },
  },
  divider: {
    height: 1,
    backgroundColor: greyStroke,
    marginBottom: 20,
  },
  filtersBody: {
    flex: 1,
  },
  formGroup: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    fontWeight: 600,
    color: squidInk,
    marginBottom: 8,
  },
  footer: {
    display: 'flex',
    gap: 12,
    paddingTop: 20,
    borderTop: `1px solid ${greyStroke}`,
  },
  applyButton: {
    backgroundColor: blackberry,
    color: white,
    border: 'none',
    borderRadius: 8,
    padding: '10px 20px',
    fontWeight: 600,
    fontSize: 14,
    flex: 1,
    ':hover': {
      backgroundColor: grape,
    },
  },
  clearButton: {
    backgroundColor: 'transparent',
    color: coolGrey,
    border: `1px solid ${greyStroke}`,
    borderRadius: 8,
    padding: '10px 20px',
    fontWeight: 600,
    fontSize: 14,
    ':hover': {
      backgroundColor: `${coolGrey}10`,
      borderColor: coolGrey,
    },
  },
});

VendorFilters.propTypes = {
  isDPPartner: PropTypes.string,
  loading: PropTypes.bool,
  setIsDPPartner: PropTypes.func,
  setShowFilters: PropTypes.func,
};

export default VendorFilters;
